import { useContext } from "react";
import { Row, Col, Dropdown } from "antd";
import { ReactComponent as Logo } from "../../res/img/logo.svg";
import { ReactComponent as World } from "../../res/img/world.svg";
import { GlobalContext } from "../../redux/globalStore";
import "./index.css";

const HeaderLogo = () => {
  const { currentLanguage, languageKeys, setLocalLanguage } =
    useContext(GlobalContext);

  const languageMap = {
    "zh-TW": "正體中文",
    "en-US": "English",
    "ja-JP": "日本語",
  };

  const items = languageKeys.map((item) => ({
    key: item,
    label: (
      <span onClick={() => setLocalLanguage(item)}>{languageMap[item]}</span>
    ),
  }));

  return (
    <Row justify={"space-between"}>
      <Col span={4} xm={4} xs={14}>
        <section className={`hd-section`}>
          <Logo className="logo" />
        </section>
      </Col>
      <Col span={20} xm={20} xs={8}>
        <div className="language-container">
          <Dropdown menu={{ items }} placement="bottom" trigger={["click"]}>
            <button>
              <World />
              <span className="language-label">
                {languageMap[currentLanguage]}
              </span>
            </button>
          </Dropdown>
        </div>
      </Col>
    </Row>
  );
};

export default HeaderLogo;
